interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  subtitle?: string;
}

export function SectionHeading({ eyebrow, title, subtitle }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between md:gap-10">
      <div className="max-w-[640px]">
        <p className="text-sm font-semibold text-primary">{eyebrow}</p>
        <h2 className="mt-3 text-4xl leading-[1.05] font-bold tracking-[-0.04em] text-balance md:text-5xl">
          {title}
        </h2>
      </div>
      {subtitle && (
        <p className="max-w-[400px] text-[15px] leading-relaxed text-muted-foreground">
          {subtitle}
        </p>
      )}
    </div>
  );
}
